import { z } from "zod"
import { UpdateOrganizationTaxRateDtoSchema } from "@mimber/schema"

export const editTaxRateSchema = UpdateOrganizationTaxRateDtoSchema

export type EditTaxRateData = z.infer<typeof editTaxRateSchema>
